<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Clinic's Recent Doctor Bookings",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Clinic's Recent Doctor Bookings",
            items: [
               {
                  text: "Clinics",
                  href: "/clinics",
               },  
               {
                  text: "Clinic's Recent Bookings",
                  active: true,
               },                   
            ],

            consultations: [],            
            
            
            keyword: '',
            status: '',
            from: null,
            to: null,
            total: null,
            pagination: {},
            showsearch: false,
            listing_length: 10,
            consultation_status: 'pending',
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
    
      },
      created() {
         this.fetchBookings();
      },

      methods: {
         fetchBookings(page_url = null) {

         this.getToken();
         let url = "api/admin/clinics/bookings?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status+ "&clinic_id=" + this.$route.params.id;

         page_url = page_url || url;

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
            localStorage.removeItem('back_url');
         }    

         this.active_page_url = page_url;
         this.loading = true;

         this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.consultations = responseData.consultations.data;
               
               this.pagination = responseData.consultations.links;
               this.from = responseData.consultations.from;
               this.to = responseData.consultations.to;
               this.total = responseData.consultations.total;
            
         })
         .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     if(typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }                        
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
         })
         .finally(() => (this.loading = false));
         }, 

         getToken() {
         if (localStorage.getItem('medicino_admin')) {
            var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
            if(medicino_admin.token) {
               this.token = medicino_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
            
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
         }, 
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'clinics' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchBookings()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchBookings()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status"  @change="fetchBookings()"> 
                                 <option value="">All</option>
                                 <option value="1">Upcoming Consultations</option>
                                 <option value="2">Completed Consultations</option>
                                 <option value="3">Cancelled Consultations</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th width="15%">User</th> 
                            <th width="15%">Patient</th>  
                              <th width="15%">Doctor</th>   
                              <th width="5%">Token</th>
                              <th width="20%">Booking Date & Slot</th>
                              <th width="20%">Status</th>
                              <th width="15%">Created On</th>
                              <th width="10%">Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(consultations.length)">
                           <tr v-for="(consultation) in consultations" :key="consultation.id">
                              <td>
                                {{ consultation.name}}<br>
                                 {{consultation.country_code}} {{consultation.mobile}}<br>
                                 {{consultation.email}}<br>
                              </td>
                              <td>
                                 <span v-if="consultation.member_name">{{ consultation.member_name}}</span>
                                 <span v-else>{{ consultation.name}}</span>
                              </td>
                              <td><span v-if="consultation.doctor">{{ consultation.doctor.prefix}} {{ consultation.doctor.name}}</span></td>
                              <td>{{ consultation.token}}</td>                 
                              <td>{{consultation.booking_date | formatDate}}<br>{{consultation.consultation_start | formatTime}} - {{consultation.consultation_end | formatTime}}</td>
                              <td><p v-if="consultation.status==1">Pending</p>
                                 <p v-if="consultation.status==2">Completed</p>
                                 <p v-if="consultation.status==3" >
                                    Cancelled<br>
                                    
                                 </p>
                              </td>
                              <td>{{consultation.created_at | formatDateTime}}</td>

                              <td>

                                 <router-link :to="{ name: 'consultations.details', params: {id: consultation.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>

                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="8" class="text-center">No bookings found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(consultations.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchBookings(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status +'&clinic_id=' + $route.params.id)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

                  <!---- modal starts ---->
                  <b-modal ref="cancel-modal" id="cancel-modal" title="Cancel Consultation" hide-footer>
                     <b-form>
                        
                        <b-col md="12" class="form-group">
                           <label class="control-label">Reason for Cancellation<span class="text-danger">*</span></label>
                           <textarea class="form-control" rows="4"></textarea>
                        </b-col>                      
                        
                        <b-col md="12">
                           <b-button type="button" class="me-3" variant="primary" @click="hideModal('cancel-modal')">Save</b-button>
                           <b-button class="" variant="light" @click="hideModal('cancel-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
